import { useMemo } from 'react';
import type { OutpatientClinicTask } from '@common/contexts/support/domain/models/outpatientClinicTaskModel';
import { formatOutpatientClinicTask } from '../utils/formatOutpatientClinicTask';

export function useFormattedOutpatientClinicTasks(tasks: OutpatientClinicTask[] | undefined) {
    return useMemo(() => {
        if (!tasks) {
            return undefined;
        }

        return tasks.map(formatOutpatientClinicTask);
    }, [tasks]);
}
